import {X} from "lucide-react";
import {useMemo} from "react";

import {cn} from "@/lib/utils";

import {Badge} from "@/components/ui/badge";

import {
  formPropertyChipLabel,
  removeFormProperty,
  sortFormPropertiesForDisplay,
  type ShiftFormProperty,
} from "../../lib/shift-property-form";

type ShiftPropertyAssignmentBadgesProps = {
  properties: ShiftFormProperty[];
  disabled?: boolean;
  onChange: (properties: ShiftFormProperty[]) => void;
};

export function ShiftPropertyAssignmentBadges({
  properties,
  disabled = false,
  onChange,
}: ShiftPropertyAssignmentBadgesProps) {
  const sorted = useMemo(() => sortFormPropertiesForDisplay(properties), [properties]);

  if (sorted.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {sorted.map((row) => {
        const isPrimary = row.assignment_type === "primary";

        return (
          <Badge
            key={`shift-property-badge-${row.id}`}
            variant={isPrimary ? "default" : "secondary"}
          >
            {formPropertyChipLabel(row)}
            {disabled ? null : (
              <button
                type="button"
                className="ring-offset-background focus:ring-ring ml-1 rounded-full outline-none focus:ring-2 focus:ring-offset-2"
                aria-label={`Remove ${row.name}`}
                onClick={() => onChange(removeFormProperty(properties, row.id))}
              >
                <X
                  className={cn(
                    "size-3",
                    isPrimary
                      ? "text-primary-foreground/80 hover:text-primary-foreground"
                      : "text-muted-foreground hover:text-foreground",
                  )}
                />
              </button>
            )}
          </Badge>
        );
      })}
    </div>
  );
}
